module.exports = __webpack_public_path__ + "static/media/mark-expectations.11e2908c.png";